import ButtonBackdee from './src/main'

ButtonBackdee.install = function (Vue) {
    Vue.component(ButtonBackdee.name, ButtonBackdee)
}

export default ButtonBackdee